if (document.querySelector('.upload-input')) {
  document.querySelector('.upload-input input').addEventListener('change', function() {
    var fileName = this.value.split('\\').pop(); // remove path from filename
    document.getElementById('uploadInputDisplay').innerText = fileName;
  });
}
